import { BasePage } from '@/components/ui/base-page'

export function LifeInsurancePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add LifeInsurancePage specific content here */}
    </BasePage>
  )
}